var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationS({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48593",
    "data-name": "Group 48593",
    transform: "translate(-983 -657)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_138031",
    "data-name": "Rectangle 138031",
    width: 24,
    height: 24,
    transform: "translate(983 657)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48573",
    "data-name": "Group 48573",
    transform: "translate(-20.75 -20.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49788",
    "data-name": "Group 49788",
    transform: "translate(-86.937 -797.019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93278",
    "data-name": "Path 93278",
    d: "M2,8.918a6.918,6.918,0,0,1,13.836,0c0,3.821-6.918,9.993-6.918,9.993S2,12.739,2,8.918",
    transform: "translate(1093.769 1476.769)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_432",
    "data-name": "Ellipse 432",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1100 1483)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationS);
export default __webpack_public_path__ + "static/media/location-s.69f2e75da3bf2b5acf34ca1d9e960405.svg";
export { ForwardRef as ReactComponent };